import { render } from "./SplashScreen.vue?vue&type=template&id=4494531d"
import script from "./SplashScreen.vue?vue&type=script&lang=js"
export * from "./SplashScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__